import React from 'react';

import { guc } from '../../Localisation';
import { isEmptyString } from '../../../utils';

const useLinkedinPartner = () => {

    const linkedinPartnerID = guc('linkedin_partner_id');

    React.useEffect(() => {
        if (!isEmptyString(linkedinPartnerID)) {
            window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
            window._linkedin_data_partner_ids.push(linkedinPartnerID);

            const script = document.createElement('script');
            script.type = 'text/javascript'; script.async = true;
            script.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';

            document.body.appendChild(script);
            return () => {
                document.body.removeChild(script);
            }
        }
    });
}

export default useLinkedinPartner;